import { duration } from 'features/timesheets/util';

import { df, moment } from 'util/dateTime';
import { toI18n } from 'util/i18n';

const LATE_CLOCK_OUT = 'late_clock_out';
const LATE_CLOCK_IN = 'late_clock_in';
const ASSISTED_CLOCK_IN = 'assisted_clock_in';

interface IssueMeta {
  time_late?: number | null;
  time_difference?: number | null;
  time_over?: number | null;
  count?: number;
  submitted_at?: string;
}

type IssueMap = Map<string, unknown> & {
  get<K extends keyof IssueMeta>(key: K): IssueMeta[K];
  getIn(path: ['meta', keyof IssueMeta]): IssueMeta[keyof IssueMeta];
};

const getIssueVariant = (issue: IssueMap) => {
  if (issue.get('type') === LATE_CLOCK_OUT) {
    return issue.get('variant');
  }
  if (issue.get('type') === LATE_CLOCK_IN) {
    return issue.get('variant') || 'error';
  }
  return 'error';
};

const getIssueMessage = (issue: IssueMap) => {
  if (issue.get('type') === LATE_CLOCK_OUT) {
    const submittedAt = issue.getIn(['meta', 'submitted_at']);
    // Use parseZone to preserve the original timezone offset
    // otherwise moment() will use the browser's local timezone
    const submittedMoment = moment(submittedAt).parseZone();
    const isToday = submittedMoment.isSame(moment(), 'day');

    const formattedTime = isToday
      ? submittedMoment.format(df('time_long'))
      : submittedMoment.format('h:mm a, ddd, MMM D');

    return toI18n(`timecard_modal_v3.issues.${LATE_CLOCK_OUT}.content`, {
      props: {
        time: formattedTime,
      },
    });
  }
  if (issue.get('type') === ASSISTED_CLOCK_IN) {
    const submittedAt = issue.getIn(['meta', 'submitted_at']);
    // Use parseZone to preserve the original timezone offset
    // otherwise moment() will use the browser's local timezone
    const submittedMoment = moment(submittedAt).parseZone();
    const isToday = submittedMoment.isSame(moment(), 'day');

    const formattedTime = isToday
      ? submittedMoment.format(df('time_long'))
      : submittedMoment.format('h:mm a, ddd, MMM D');

    return toI18n(`timecard_modal_v3.issues.${ASSISTED_CLOCK_IN}.content`, {
      props: {
        time: formattedTime,
      },
    });
  }
  if (
    issue.get('type') === 'over_scheduled' &&
    issue.getIn(['meta', 'time_over'])
  ) {
    const formattedTimeOver = duration(issue.getIn(['meta', 'time_over']), {
      withSpace: false,
    });
    return toI18n(`timecard_modal_v3.issues.over_scheduled.content`, {
      props: { time_over: formattedTimeOver },
    });
  }
  return toI18n(`timecard_modal_v3.issues.${issue.get('type')}.content`, {
    props: { count: issue.getIn(['meta', 'count']) },
  });
};

export { getIssueVariant, getIssueMessage };
